module.exports = __webpack_public_path__ + "img/tlfdys.209605a1.png";